module.exports = __webpack_public_path__ + "banquet/components/images/quantity_increase.a739bdb099c81e33c733c6fbe2929ce8.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/quantity_increase.svg
// module id = 1044
// module chunks = 1